// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1cZfQ","right":"styles_right__CeaJ8"};